import React from 'react';
import BaseMobileDrawer from '../BaseMobileDrawer/BaseMobileDrawer';
import { ModalBody, ModalText, TitleWrapper } from './MobileCommonDrawer.styles';
import { getDefaultTitle, getIcon, MobileCommonDrawerProps } from './MobileCommonDrawer.utils';

const MobileCommonDrawer: React.FC<MobileCommonDrawerProps> = ({
  isOpen,
  onClose,
  type,
  title,
  message,
  primaryButton,
  secondaryButton,
  numberOfUnresolvedCompressors,
}) => {
  const renderContent = () => (
    <ModalBody>
      <ModalText>
        {type === 'unresolved' && numberOfUnresolvedCompressors
          ? `${numberOfUnresolvedCompressors} ${message}`
          : message}
      </ModalText>
    </ModalBody>
  );

  return (
    <BaseMobileDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={
        <TitleWrapper>
          {getIcon(type)}
          <span className={`${type === 'cancelTest' && 'font-weight-strong'}`}>{title || getDefaultTitle(type)}</span>
        </TitleWrapper>
      }
      primaryButton={{
        ...primaryButton,
        variant: primaryButton.variant || 'primary',
      }}
      secondaryButton={secondaryButton}
    >
      {renderContent()}
    </BaseMobileDrawer>
  );
};

export default MobileCommonDrawer;
